import { HTMLAttributes } from "react";
// import "./styles/index.css";
import { cn, createStyleCSSProperty } from "../helper/helper";
import React from "react";
import Image from "../image/Image";
import { Util } from "../helper/utility";

interface IProps {
  children: React.ReactNode;
  className?: string;
}
type SN = string | number;
interface StackProps extends HTMLAttributes<HTMLDivElement> {
  /** Defaults to 2.4rem, and if number is passed, it coerced to rem */
  gap?: SN;
}

function createStackGap(gap: SN) {
  return createStyleCSSProperty("--stack-gap", gap);
}

export const Column = (props: StackProps) => {
  const { children, className, gap = "2.4rem", style, ...rest } = props;

  return (
    <div
      style={{ ...createStackGap(gap), ...style }}
      className={cn("ystack", className)}
      {...rest}
    >
      {children}
    </div>
  );
};

interface RowProps extends StackProps {
  ai?: React.CSSProperties["alignItems"];
}
export const Row = (props: RowProps) => {
  const { children, className, gap = "2.4rem", style, ai, ...rest } = props;

  return (
    <div
      style={{ ...createStackGap(gap), alignItems: ai, ...style }}
      className={cn("xstack", className)}
      {...rest}
    >
      {children}
    </div>
  );
};

interface BillerProps {
  biller: string | JSX.Element;
  provider: string;
}

export const BillerStack = ({ biller, provider }: BillerProps) => (
  <Row style={{ alignItems: "center", zIndex: 0 }} className="biller-row">
    <figure className="biller-logo">
      {typeof biller === "string" ? <Image src={biller} alt="" /> : biller}
    </figure>
    <p>{Util.safeValue(provider)}</p>
  </Row>
);

interface ControlledTableContentProps extends IProps {
  maxWidth?: SN;
}

export const ControlledTableContent = (props: ControlledTableContentProps) => {
  const { maxWidth, children, className } = props;
  return (
    <div
      style={
        maxWidth
          ? { ...createStyleCSSProperty("--cc-max-width", maxWidth) }
          : undefined
      }
      className={cn("controlled-table-content", className)}
    >
      {children}
    </div>
  );
};
